import QuotesViewer from "./QuotesViewer";
import XeroFeatureFlagCheck from "../../../../../utils/XeroFeatureFlagCheck";

function QuotesViewerWrapper() {
    return (
        <XeroFeatureFlagCheck>
            <QuotesViewer />
        </XeroFeatureFlagCheck>
    )
}

export default QuotesViewerWrapper;